import styled, { keyframes } from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import { aiAgentColors } from 'constants/aiAgentColors';

import type { CraftEmailChatMessage } from '../../../../features/craft-email-agent/types';

const chatMsgIn = keyframes`
  0% {
    opacity: 0;
    transform: translateY(6px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const typingDotPulse = keyframes`
  0%,
  80%,
  100% {
    opacity: 0.35;
    transform: scale(0.85);
  }
  40% {
    opacity: 1;
    transform: scale(1);
  }
`;

export const StyledChatMessages = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  padding: 8px 0 48px;
`;

export const StyledChatMsg = styled.div<{ $role: CraftEmailChatMessage['role'] }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  animation: ${chatMsgIn} 0.2s ease;
  width: 100%;
  align-items: ${({ $role }) => ($role === 'user' ? 'flex-end' : 'flex-start')};
  padding: ${({ $role }) => ($role === 'user' ? '0 20px' : '0')};
  scroll-margin-top: 8px;
`;

export const StyledUserBubble = styled.div`
  max-width: 85%;
  padding: 10px 24px;
  border-radius: 20px;
  ${setFontVariant('body2', colorsPalettes.carbon[500])};
  background: ${aiAgentColors.lightBlue};
  white-space: pre-wrap;
  word-break: break-word;
`;

export const StyledAiText = styled.div`
  ${setFontVariant('sectionTitle', colorsPalettes.carbon[300])};
  padding: 0 20px;
  white-space: pre-wrap;
  word-break: break-word;

  strong {
    font-weight: 600;
    color: ${colorsPalettes.carbon[500]};
  }
`;

export const StyledTypingRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  padding: 0 20px;
  animation: ${chatMsgIn} 0.2s ease;
`;

export const StyledTypingBubble = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 10px 16px;
  border-radius: 20px;
  background: ${colorsPalettes.bluegrey[100]};
  min-height: 36px;
`;

export const StyledTypingDot = styled.span<{ $delay: number }>`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${colorsPalettes.carbon[300]};
  animation: ${typingDotPulse} 1s ease-in-out infinite;
  animation-delay: ${({ $delay }) => $delay}ms;
`;
